/* import {useApplicationInsights} from '@sttedra_ui/framework';

export default [
  (to) => {
    console.log('M_APP_INSIGHTS_TRACK_INSTRUMENTATION_KEY',
      M_APP_INSIGHTS_TRACK_INSTRUMENTATION_KEY);
    console.log('Tracking page:', to.fullPath);
    const appInsights = useApplicationInsights();
    if (appInsights) {
      appInsights.trackPageView({
        name: to.name || to.path,
        uri: to.fullPath,
      });
    }
  },
]; */
